import { BaseApiRouteService } from "mrb/core";

class UploadedContentApiRouteService extends BaseApiRouteService {
    constructor() {
        super("admin/uploaded-content");
    }

    find(options) {
        const toParam = (v) =>
            Array.isArray(v) && v.length ? v.join(",") : undefined;
        return this.uriTemplateService
            .parse(`${this.base}{?search,producer,artist,album,contentType,session,page,rpp,sortBy,sortDirection}`)
            .expand({
                search: options.search || undefined,
                producer: toParam(options.producer),
                artist: toParam(options.artist),
                album: toParam(options.album),
                contentType: options.contentType || undefined,
                session: options.session || undefined,
                page: options.pageNumber || undefined,
                rpp: options.pageSize || undefined,
                sortBy: options.orderBy || undefined,
                sortDirection: options.orderDirection || undefined,
            });
    }

    sessions(options) {
        const toParam = (v) =>
            Array.isArray(v) && v.length ? v.join(",") : undefined;
        return this.uriTemplateService
            .parse(`${this.base}/sessions{?search,producer,artist,album,page,rpp,sortBy,sortDirection}`)
            .expand({
                search: options.search || undefined,
                producer: toParam(options.producer),
                artist: toParam(options.artist),
                album: toParam(options.album),
                page: options.pageNumber || undefined,
                rpp: options.pageSize || undefined,
                sortBy: options.orderBy || undefined,
                sortDirection: options.orderDirection || undefined,
            });
    }

    getFilterOptions() {
        return `${this.base}/filter-options`;
    }

    getDownloadUrls() {
        return `${this.base}/download-urls`;
    }

    getFileDownload(key) {
        return this.uriTemplateService
            .parse(`${this.base}/download{?key}`)
            .expand({ key });
    }

    getSessionDescription(sessionId) {
        return `${this.base}/sessions/${sessionId}/description`;
    }
}

export default UploadedContentApiRouteService;
